import { Component, ViewChild, Input, Output, EventEmitter, OnInit/*, AfterViewChecked*/, OnDestroy, Renderer2, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Moment } from 'moment';
import * as moment from 'moment';
import * as fileSaver from 'file-saver';
//import { IntervalObservable } from 'rxjs/observable/IntervalObservable';
//import 'rxjs/add/operator/takeWhile';

//import { ItemOrderHistoryBase } from 'app/buffer-graph/models/item-order-history/item-order-history-base';
import { ItemOrderHistory } from 'app/buffer-graph/models/item-order-history/item-order-history';
import { ItemOrderHistoryFresh } from 'app/buffer-graph/models/item-order-history/item-order-history-fresh';
import { Formatters } from 'app/slick-grid/models/formatters';
import { SlickGridComponent } from 'app/slick-grid/slick-grid.component';
import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import { EventArgs } from 'app/slick-grid/models/event-args';
import { ISlickGridColumn } from 'app/slick-grid/interfaces/slick-grid-column'
import { OnDropdownFilteredEventArgs } from 'app/slick-grid/models/on-dropdown-filtered-event-args';
import { DropdownFilterType } from 'app/slick-grid/interfaces/dropdown-filter-type';
import { DataSorter } from 'app/slick-grid/models/data-sorter';
import { TabComponentBase } from 'app/buffer-graph/models/tab-component-base';

type History = ItemOrderHistory | ItemOrderHistoryFresh;
type ExportData = { columns: { header: string, field: string }[], mainRows: any[][], cwhRows: any[][] };

@Component({
    selector: 'item-order-history',
    templateUrl: './item-order-history.component.html',
    styleUrls: ['./item-order-history.component.css']
})
export class ItemOrderHistoryComponent extends TabComponentBase<History, ExportData> {//implements OnInit/*, AfterViewChecked*/, OnDestroy {
    constructor(graphService: BufferGraphService, private readonly translateService: TranslateService, private readonly renderer: Renderer2, private readonly elementRef: ElementRef) {
        super(graphService);

        this.showAllData = new EventEmitter<void>();

        this.options = { syncColumnCellResize: true, multiColumnSort: true, editable: false };
        this.dataView = new Slick.Data.DataView<History>({ inlineFilters: false });
        this.dataView.onRowsChanged.subscribe(() => this.setCellCssStyles());
    }

    @ViewChild('grid')
    protected gridRef: SlickGridComponent;

    @Input()
    protected isActive: boolean;

    private isFresh: boolean;
    @Input()
    private set fresh(value: boolean) {
        if (this.isFresh === value && this.isFresh != null)
            return;

        this.isFresh = value;
        this.setColumns();
    }

    @Input()
    private allShown: boolean;

    private data: History[];
    @Input()
    private set orders(orders: History[]) {
        this.data = orders;
        setTimeout(() => {
            this.dropdownFilters = [];

            this.dataView.beginUpdate();
            this.dataView.setItems(this.getLinearDataTree(orders));
            this.dataView.setFilter(o => this.filterOrder(o));
            this.dataView.endUpdate();
            //this.setCellCssStyles();

            if (this.columns)
                this.setColumns();
        },
            1);
    }

    @Input()
    private showCodes: boolean;

    @Input()
    protected sku: string;

    @Input()
    protected warehouseCode: string;

    @Input()
    protected canSend: boolean;

    @Output()
    private readonly showAllData: EventEmitter<void>;

    //private readonly alertTime = 10000;

    private readonly statusFulfillmentStylesKey = 'status-fulfillment';

    //private columns: ISlickGridColumn<History>[];

    //private readonly options: Slick.GridOptions<History>;

    //private readonly dataView: Slick.Data.DataView<History>;

    private cellCssStyles: { [key: string]: Slick.CellCssStylesHash };

    //private destroyed: boolean;

    //private showExportError: boolean;

    //private showExportErrorTimer: any;

    //private showSendError: boolean;

    //private showSendErrorTimer: any;

    //private showSendSuccess: boolean;

    //private showSendSuccessTimer: any;

    private dropdownFilters: OnDropdownFilteredEventArgs<History>[];

    //private sending: boolean;

    //private exporting: boolean;

    //ngOnInit(): void {
    //    this.graphService.onTabsResized.takeWhile(() => !this.destroyed).subscribe(() => {
    //        if (this.gridRef)
    //            this.gridRef.resizeGrid();
    //    });
    //}

    //ngAfterViewChecked(): void {
    //}

    //ngOnDestroy(): void {
    //    this.destroyed = true;
    //}

    private setColumns = (): void => {
        const hasCrossDock = (this.dataView.getItems() || []).some(o => o.crossDock != null);
        const formatValue = (r: any, c: any, v: any, col: any, order: any, formatter: Slick.Formatter<any>): string => {
            let toggler = '';
            if (c === 0 && hasCrossDock)
                toggler = `<span class="toggle fa fa-fw ${order.crossDock == null ? '' : order.crossDock.visible ? 'fa-minus-square-o' : 'fa-plus-square-o'} mr-1"></span>`;

            return `${toggler}${formatter(r, c, v, col, order)}`;
        }
        let columns: ISlickGridColumn<History>[] = [
            { id: 'date', field: 'date', name: 'Date', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.dateFormatter(r, c, v)), dropdownFilter: { dropdownContainer: this.elementRef.nativeElement, renderer: this.renderer, displayFormatter: v => Formatters.dateFormatter(null, null, v), sortFormatter: v => v == null ? '' : (v as Moment).format('YYYY-MM-DD HH:mm:ss'), sourceFilter: o => !o.isCwhOrder } },
            { id: 'planArriveDate', field: 'planArriveDate', name: 'PlannedArrivalDate', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.dateFormatter(r, c, v)), dropdownFilter: { dropdownContainer: this.elementRef.nativeElement, renderer: this.renderer, displayFormatter: v => Formatters.dateFormatter(null, null, v), sortFormatter: v => v == null ? '' : (v as Moment).format('YYYY-MM-DD HH:mm:ss'), sourceFilter: o => !o.isCwhOrder } }
        ];

        if (this.isFresh)
            columns = columns.concat([
                { id: 'nextInputDate', field: 'nextInputDate', name: 'NextArrivalDate', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.dateFormatter(r, c, v)) },
                { id: 'orderTime', field: 'orderTime', name: 'OrderTime', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.timeFormatter(r, c, v)) },
                { id: 'deliveryTime', field: 'deliveryTime', name: 'DeliveryTime', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.timeFormatter(r, c, v)) },
                { id: 'lifeTime', field: 'lifeTime', name: 'StoragePeriod', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.numberFormatter(r, c, v, 0)) },
                { id: 'weekSale', field: 'weekSale', name: 'ForecastSale', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.numberFormatter(r, c, v, 2)) },
                { id: 'lastWeekSale', field: 'lastWeekSale', name: 'ForecastSale', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.numberFormatter(r, c, v, 2)) },
                { id: 'changedCoeff', field: 'changedCoeff', name: 'StockCoeff', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.numberFormatter(r, c, v, 2)) },
                { id: 'baseBuffer', field: 'baseBuffer', name: 'BaseBuffer', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.numberFormatter(r, c, v, 2)) },
                { id: 'actionQnt', field: 'actionQnt', name: 'PromotionalBuffer', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.numberFormatter(r, c, v, 2)) },
                { id: 'newMover', field: 'newMover', name: 'New', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => v || '') },
                { id: 'hasHolidayQnt', field: 'hasHolidayQnt', name: 'HolidayOrder', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => v || '') }
            ]);

        columns = columns.concat([
            { id: 'order', field: 'order', name: 'Order', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.numberFormatter(r, c, v, 2)) },
            { id: 'statusDescr', field: 'statusDescr', name: 'Status', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => v || '') },
            { id: 'fulfillmentDescr', field: 'fulfillmentDescr', name: 'Fulfillment', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => v || '') },
            { id: 'arrivalDate', field: 'arrivalDate', name: 'ArrivalDate', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.dateFormatter(r, c, v)) },
            { id: 'arrivedQuantity', field: 'arrivedQuantity', name: 'ArrivedOrder', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.numberFormatter(r, c, v, 2)) },
            { id: 'supplierCode', field: 'supplierCode', name: 'SupplierCode', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => v || '') },
            { id: 'supplierName', field: 'supplierName', name: 'Supplier', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => v || ''), dropdownFilter: { dropdownContainer: this.elementRef.nativeElement, renderer: this.renderer/*, displayFormatter: v => v, sortFormatter: v => v == null ? '' : v*/, sourceFilter: o => !o.isCwhOrder } },
            { id: 'buffer', field: 'buffer', name: 'Buffer', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.numberFormatter(r, c, v, 4)) },
            { id: 'safetyStock', field: 'safetyStock', name: 'SafetyStock', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.numberFormatter(r, c, v, 2)) },
            { id: 'balance', field: 'balance', name: 'Balance', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.numberFormatter(r, c, v, 2)) },
            { id: 'inTransit', field: 'inTransit', name: 'InTransit', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.numberFormatter(r, c, v, 2)) },
            { id: 'need', field: 'need', name: 'Need', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => Formatters.numberFormatter(r, c, v, 2)) },
            { id: 'hasData', field: 'hasData', name: 'Data', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => v || '') },
            { id: 'hasMoq', field: 'hasMoq', name: 'Moq', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => v || '') },
            { id: 'hasMoa', field: 'hasMoa', name: 'Moa', sortable: true, formatter: (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => v || '') }
        ]);
        this.columns = columns;
    }

    private getLinearDataTree = (orders: History[]): History[] => {
        const array: History[] = [];
        orders.forEach(o => {
            array.push(o);
            if (o.crossDock)
                array.push(o.crossDock);
        });
        return array;
    }

    private setCellCssStyles = (): void => {
        let styles: Slick.CellCssStylesHash = null;
        this.dataView.getItems().forEach(o => {
            const row = this.dataView.getRowById(o.id);
            if (row == null)
                return;

            let statusClass: string = null;
            if (o.status > 0) {
                switch (o.status) {
                case 1:
                    statusClass = 'came-in-time';
                    break;
                case 2:
                    statusClass = 'late';
                    break;
                case 3:
                    statusClass = 'not-fulfillded';
                    break;
                case 4:
                    statusClass = 'in-transit';
                    break;
                case 5:
                    statusClass = 'in-transit-late';
                    break;
                case 6:
                    statusClass = 'order-canceled';
                    break;
                case 7:
                    statusClass = 'no-data';
                    break;
                case 8:
                    statusClass = 'order-blocked';
                    break;
                }
            }

            let fulfillmentClass: string = null;
            switch (o.fulfillment) {
            case 1:
                fulfillmentClass = 'came-more';
                break;
            case 2:
                fulfillmentClass = 'came-less';
                break;
            case 3:
                fulfillmentClass = 'came-all';
                break;
            }

            if (!statusClass && !fulfillmentClass)
                return;

            if (styles == null)
                styles = {};

            styles[row] = {};
            if (statusClass != null)
                styles[row]['statusDescr'] = statusClass;
            if (fulfillmentClass != null)
                styles[row]['fulfillmentDescr'] = fulfillmentClass;
        });

        if (styles == null)
            this.cellCssStyles = null;
        else {
            this.cellCssStyles = {};
            this.cellCssStyles[this.statusFulfillmentStylesKey] = styles;
        }
    }

    //private export = (toEmail?: boolean): void => {
    //    if (toEmail)
    //        this.sending = true;
    //    else
    //        this.exporting = true;

    //    const columns = this.gridRef.getColumns().map(c => { return { header: c.name, field: c.field }; })
    //        .concat([{ header: null, field: 'status' }, { header: null, field: 'fulfillment' }]);
    //    const mainRows = [];
    //    const cwhRows = [];

    //    const pushToRow = (val: any, array: any[]): void => {
    //        if (moment.isMoment(val))
    //            array.push(val.toJSON());
    //        else if (moment.isDuration(val))
    //            array.push(moment(val.asMilliseconds()).toJSON());
    //        else
    //            array.push(`${val == null ? '' : val}`);
    //    };

    //    const length = this.dataView.getLength();
    //    for (let i = 0; i < length; i++) {
    //        const order = this.dataView.getItemByIdx(i);

    //        if (order.isCwhOrder)
    //            continue;

    //        const mainRow = [];
    //        const cwhRow = order.crossDock ? [] : null;
    //        columns.forEach(c => {
    //            pushToRow(order[c.field], mainRow);
    //            if (cwhRow)
    //                pushToRow(order.crossDock[c.field], cwhRow);
    //        });
    //        mainRows.push(mainRow);
    //        if (cwhRow)
    //            cwhRows.push(cwhRow);
    //    }
    //    const showError = (): void => {
    //        if (toEmail) {
    //            this.showExportError = false;
    //            this.showSendSuccess = false;

    //            if (this.showSendErrorTimer)
    //                clearTimeout(this.showSendErrorTimer);

    //            this.showSendError = true;
    //            setTimeout(() => {
    //                this.showSendError = false;
    //                clearTimeout(this.showSendErrorTimer);
    //            },
    //                this.alertTime);
    //            return;
    //        }

    //        this.showSendError = false;
    //        this.showSendSuccess = false;

    //        if (this.showExportErrorTimer)
    //            clearTimeout(this.showExportErrorTimer);

    //        this.showExportError = true;
    //        setTimeout(() => {
    //            this.showExportError = false;
    //            clearTimeout(this.showExportErrorTimer);
    //        },
    //            this.alertTime);
    //    };

    //    this.translateService.get(['ItemOrderHistory', 'CwhOrders']).subscribe(t => {
    //        if (toEmail) {
    //            this.graphService.sendItemOrderHistory(this.sku, this.warehouseCode, columns, mainRows, cwhRows, moment.locale(), t.ItemOrderHistory, t.CwhOrders).subscribe(data => {
    //                this.sending = false;

    //                if (data && data.success) {
    //                    if (this.showSendSuccess)
    //                        clearTimeout(this.showSendSuccessTimer);

    //                    this.showExportError = false;
    //                    this.showSendError = false;
    //                    this.showSendSuccess = true;
    //                    setTimeout(() => {
    //                        this.showSendSuccess = false;
    //                        clearTimeout(this.showSendSuccessTimer);
    //                    },
    //                        this.alertTime);
    //                    return;
    //                }

    //                showError();
    //            }, () => {
    //                this.sending = false;
    //                showError();
    //            });
    //            return;
    //        }

    //        this.graphService.downloadItemOrderHistory(columns, mainRows, cwhRows, moment.locale(), t.ItemOrderHistory, t.CwhOrders).subscribe(data => {
    //            this.exporting = false;
    //            if (data && data.size > 0) {
    //                fileSaver.saveAs(data, `ItemOrderHistory_SKU_${this.sku}_Wrh_${this.warehouseCode}.xlsx`);
    //                return;
    //            }

    //            showError();
    //        }, () => {
    //            this.exporting = false;
    //            showError();
    //        });
    //    });
    //}

    private filterOrder = (order: History): boolean => {
        if (order.isCwhOrder)
            return order.visible && !order.hiddenByFilter;

        for (const filter of this.dropdownFilters) {
            const value = order[filter.column.field];

            let result: boolean;

            switch (filter.type) {
                case DropdownFilterType.Blank:
                    result = value == null || value === '';
                    break;
                case DropdownFilterType.NonBlank:
                    result = value != null && value !== '';
                    break;
                case DropdownFilterType.ByValue:
                    result = moment.isMoment(filter.value) ? filter.value.isSame(value) : filter.value === value;
                    break;
                default:
                    result = true;
            }

            if (result)
                continue;

            if (order.crossDock != null)
                order.crossDock.hiddenByFilter = true;

            return false;
        }

        if (order.crossDock != null)
            order.crossDock.hiddenByFilter = false;

        return true;
    }

    private onShowAllClick = (): void => {
        if (this.allShown)
            return;

        this.showAllData.emit();
    }

    private onGridClick = (args: EventArgs<Slick.OnClickEventArgs<History>>): void => {
        if (args.data.cell !== 0)
            return;

        const target = (args.event as UIEvent).target;
        if (!(target instanceof HTMLElement) || !(target as HTMLElement).classList.contains('toggle'))
            return;

        const order = this.dataView.getItemByIdx(args.data.row);
        if (order.crossDock == null)
            return;
        order.crossDock.visible = !order.crossDock.visible;
        this.dataView.updateItem(order.id, order);
        //this.setCellCssStyles();
    }

    protected getExportData = (): ExportData => {
        const columns = this.gridRef.getColumns().map(c => { return { header: c.name, field: c.field }; })
            .concat([{ header: null, field: 'status' }, { header: null, field: 'fulfillment' }]);
        const mainRows = [];
        const cwhRows = [];

        const pushToRow = (val: any, array: any[]): void => {
            if (moment.isMoment(val))
                array.push(val.toJSON());
            else if (moment.isDuration(val))
                array.push(moment(val.asMilliseconds()).toJSON());
            else
                array.push(`${val == null ? '' : val}`);
        };

        const length = this.dataView.getLength();
        for (let i = 0; i < length; i++) {
            const order = this.dataView.getItemByIdx(i);

            if (order.isCwhOrder)
                continue;

            const mainRow = [];
            const cwhRow = order.crossDock ? [] : null;
            columns.forEach(c => {
                pushToRow(order[c.field], mainRow);
                if (cwhRow)
                    pushToRow(order.crossDock[c.field], cwhRow);
            });
            mainRows.push(mainRow);
            if (cwhRow)
                cwhRows.push(cwhRow);
        }

        return { columns, mainRows, cwhRows };
    }

    private onDownloadClick = (): void => {
        const fileName = `ItemOrderHistory_SKU_${this.sku}_Wrh_${this.warehouseCode}.xlsx`;
        this.translateService.get(['ItemOrderHistory', 'CwhOrders']).subscribe(t => {
            this.download(data => this.graphService.downloadItemOrderHistory(data.columns, data.mainRows, data.cwhRows, moment.locale(), t.ItemOrderHistory, t.CwhOrders).map(file => { return { fileContent: file, fileName }; }));
        });
    }

    private onSendClick = (): void => {
        this.translateService.get(['ItemOrderHistory', 'CwhOrders']).subscribe(t => {
            this.sendToEmail(data => this.graphService.sendItemOrderHistory(this.sku, this.warehouseCode, data.columns, data.mainRows, data.cwhRows, moment.locale(), t.ItemOrderHistory, t.CwhOrders));
        });
    }

    //private onHideExportErrorClick = (): void => {
    //    setTimeout(() => this.showExportError = false, 500);
    //}

    //private onHideSendErrorClick = (): void => {
    //    setTimeout(() => this.showSendError = false, 500);
    //}

    //private onHideSendSuccessClick = (): void => {
    //    setTimeout(() => this.showSendSuccess = false, 500);
    //}

    private onGridSort = (args: EventArgs<Slick.OnSortEventArgs<History>>): void => {
        const sorter = new DataSorter < History>();
        const sort: (a: History, b: History) => number = args.data.multiColumnSort
            ? (a, b) => sorter.multiColumnSorter(a, b, args.data.sortCols)
            : (a, b) => sorter.sorter(a, b, args.data.sortCol, args.data.sortAsc);
        this.data.sort(sort);
        this.dataView.setItems(this.getLinearDataTree(this.data));
    }

    private onGridDropdownFiltered = (args: EventArgs<OnDropdownFilteredEventArgs<History>>): void => {
        const idx = this.dropdownFilters.findIndex(f => f.column.field === args.data.column.field);
        if (idx >= 0)
            this.dropdownFilters.splice(idx, 1);

        if (args.data.type === DropdownFilterType.All) {
            if (idx < 0)
                return;
        } else
            this.dropdownFilters.push(args.data);

        this.dataView.refresh();
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/item-order-history.component/item-order-history.component.ts